/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoyaltyUser } from '../../models/loyalty-user';

export interface GetLoyaltyUser$Params {
  'Active-Tenant-Identifier': string;
  userId: string;
}

export function getLoyaltyUser(http: HttpClient, rootUrl: string, params: GetLoyaltyUser$Params, context?: HttpContext): Observable<StrictHttpResponse<LoyaltyUser>> {
  const rb = new RequestBuilder(rootUrl, getLoyaltyUser.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LoyaltyUser>;
    })
  );
}

getLoyaltyUser.PATH = '/loyalty/users/{userId}';
